/**
 * 文件说明:
 *
 * hz ContentHeader component
 *
 * ----------------------------------------
 * 创建用户: leo
 */
import {memo, forwardRef} from 'react'
import {ContentHeader} from '@huzan/hz-layout'
import classnames from 'classnames'
import styles from './index.less'

const ContentHeaderWarp = memo(
    forwardRef((props, ref) => {
        const {className, content, ...restProps} = props

        if (content?.descriptionOption?.popoverOption) {
            content.descriptionOption.popoverOption.arrowPointAtCenter =
                content.descriptionOption.popoverOption.arrowPointAtCenter ?? true
        }

        return (
            <ContentHeader
                className={classnames(styles.main, className)}
                {...restProps}
                content={content}
                ref={ref}
            />
        )
    }),
)

export default ContentHeaderWarp
